import { entitiesPayload as payexEntitiesPayload } from 'actions/entities/orders/orders';
import type { FieldEntityType } from 'models/field';
import type { RootState } from 'reducers/types';
import { getFieldValue } from 'selectors';

export const entitiesPayload = (
  entityOrEntities: FieldEntityType | FieldEntityType[],
  state: RootState,
) => {
  const payload = payexEntitiesPayload(entityOrEntities, state);
  const callbackUrl = getFieldValue(state, 'callback_url');
  const callbackVersion = getFieldValue(state, 'callback_version');

  const hasCallbackUrl = callbackUrl && (callbackUrl as string).length > 0;
  const isCallbackV2 = callbackVersion === '2';

  const callback = {
    id: getFieldValue(state, 'callback_id'),
    ...(hasCallbackUrl ? { url: callbackUrl } : {}),
    ...(isCallbackV2 ? { version: '2' } : {}),
  };

  return { ...payload, callback };
};
